<template>
  <div class="supplier-contract-edit-container">
    <div class="page-header">
      <div class="blue-bar"></div>
      <h2 class="page-title">{{ contractId ? '编辑合同' : '新增合同' }}</h2>
    </div>
    
    <el-form :model="contractForm" :rules="rules" ref="contractForm" label-width="0" class="contract-form">
      <div class="form-section">
        <div class="form-row">
          <div class="form-item">
            <label class="required-label">合同名称</label>
            <el-input v-model="contractForm.contract_name" placeholder="请输入"></el-input>
          </div>
          <div class="form-item">
            <label class="required-label">选择供应商</label>
            <el-select 
              v-model="contractForm.supplier_id" 
              placeholder="请选择"
              filterable
            >
              <el-option
                v-for="item in supplierOptions"
                :key="item.id"
                :label="item.unit_name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <div class="form-item">
            <label class="required-label">交付时间</label>
            <el-date-picker
              v-model="contractForm.delivery_date"
              type="date"
              placeholder="请输入"
              style="width: 100%"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </div>
        </div>
        
        <div class="form-row">
          <div class="form-item">
            <label class="required-label">计价方式</label>
            <el-select v-model="contractForm.price_method" placeholder="固定价">
              <el-option label="固定价" value="固定价"></el-option>
              <el-option label="变动价" value="变动价"></el-option>
            </el-select>
          </div>
          <div class="form-item">
            <label class="required-label">是否计息</label>
            <div class="radio-group">
              <div class="radio-option">
                <el-radio v-model="contractForm.is_interest" label="是">是</el-radio>
              </div>
              <div class="radio-option">
                <el-radio v-model="contractForm.is_interest" label="否">否</el-radio>
              </div>
            </div>
          </div>
          <div class="form-item"></div>
        </div>
        
        <div class="form-row">
          <div class="form-item wide">
            <label class="required-label">结算方式</label>
            <div class="radio-group">
              <div class="radio-option large">
                <el-radio v-model="contractForm.settlement_method" label="每月20日结算">每月20日结算</el-radio>
              </div>
              <div class="radio-option large">
                <el-radio v-model="contractForm.settlement_method" label="按结算金额全额开具发票">按结算金额全额开具发票</el-radio>
              </div>
            </div>
          </div>
        </div>
        
        <div class="form-row">
          <div class="form-item wide">
            <label class="required-label">付款方式</label>
            <div class="payment-wrapper">
              <div class="payment-input-group">
                <div class="payment-prefix">每</div>
                <el-input v-model="contractForm.payment_days" placeholder="请输入天数" class="day-input"></el-input>
                <span class="label-text">天</span>
                <span class="payment-text">结算金额, 次月最低支付70%</span>
              </div>
              
              <div class="payment-input-group payment-second-row">
                <div class="payment-prefix" style="visibility: hidden;">每</div>
                <el-input v-model="contractForm.payment_days_second" placeholder="请输入天数" class="day-input"></el-input>
                <span class="label-text">天</span>
                <span class="payment-text">结算金额付至100%</span>
              </div>
            </div>
          </div>
        </div>
        
        <div class="form-row">
          <div class="form-item wide">
            <label class="required-label">计息条件</label>
            <el-input v-model="contractForm.interest_condition" placeholder="请输入免息期"></el-input>
          </div>
        </div>
        
        <div class="form-row">
          <div class="form-item wide">
            <div class="interest-rate-wrapper">
              <!-- 固定利率 -->
              <div class="interest-rate-group">
                <div class="rate-radio-container">
                  <el-radio v-model="contractForm.interest_type" label="固定利率" class="rate-radio">固定利率</el-radio>
                </div>
                <div class="rate-inputs-container">
                  <el-input 
                    v-model="contractForm.fixed_interest_rate" 
                    placeholder="请输入固定利率" 
                    class="rate-input"
                    :disabled="contractForm.interest_type !== '固定利率'"
                  ></el-input>
                  <span class="label-text">%</span>
                </div>
              </div>
              
              <!-- 变动利率标题行 -->
              <div class="interest-rate-group">
                <div class="rate-radio-container">
                  <el-radio v-model="contractForm.interest_type" label="变动利率" class="rate-radio">变动利率</el-radio>
                </div>
                <div class="rate-inputs-container">
                  <el-button 
                    v-if="contractForm.interest_type === '变动利率'"
                    type="primary" 
                    class="add-btn" 
                    icon="el-icon-plus"
                    @click="addVariableRate"
                  >新增变动利率</el-button>
                </div>
              </div>
              
              <!-- 变动利率列表 -->
              <template v-if="contractForm.interest_type === '变动利率'">
                <div 
                  v-for="(rate, index) in variableRates" 
                  :key="index"
                  class="interest-rate-group variable-rate-row"
                >
                  <div class="rate-radio-container"></div>
                  <div class="rate-inputs-container">
                    <el-input 
                      v-model="rate.days" 
                      placeholder="请输入天数" 
                      class="day-input"
                    ></el-input>
                    <span class="label-text">天</span>
                    <el-input 
                      v-model="rate.rate" 
                      placeholder="请输入变动利率" 
                      class="rate-input percent"
                    ></el-input>
                    <span class="label-text">%</span>
                    <el-button 
                      type="danger" 
                      class="delete-btn" 
                      icon="el-icon-delete"
                      @click="removeVariableRate(index)"
                    >删除</el-button>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      
      <div class="table-section">
        <el-upload
          class="excel-uploader"
          action="#"
          :show-file-list="false"
          :before-upload="beforeExcelUpload"
          :http-request="handleExcelUpload"
        >
          <el-button v-permission="'contracts:supplier-contract-edit:import'" type="primary" class="import-btn" icon="el-icon-download">导入清单</el-button>
        </el-upload>
        
        <el-table :data="contractForm.products" border style="width: 100%; margin-top: 20px;">
          <el-table-column label="分类" prop="category" width="80"></el-table-column>
          <el-table-column label="序号" prop="seq_no" width="60"></el-table-column>
          <el-table-column label="材料名称" prop="material_name" width="120"></el-table-column>
          <el-table-column label="规格型号" prop="spec_model" width="130"></el-table-column>
          <el-table-column label="单位" prop="unit" width="60"></el-table-column>
          <el-table-column label="数量" prop="quantity" width="60"></el-table-column>
          <el-table-column label="单价金额（元）" prop="unit_price" width="120">
            <template slot-scope="scope">
              {{ formatUnitPrice(scope.row.unit_price) }}
            </template>
          </el-table-column>
          <el-table-column label="税率" prop="tax_rate" width="80">
            <template slot-scope="scope">
              {{ formatTaxRate(scope.row.tax_rate) }}
            </template>
          </el-table-column>
          <el-table-column label="含税单价（元）" prop="tax_price" width="120"></el-table-column>
          <el-table-column label="操作" width="80">
            <template slot-scope="scope">
              <el-button v-permission="'contracts:supplier-contract-edit:delete-item'" type="text" size="small" @click="removeProduct(scope.$index)" class="delete-btn">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      
      <div class="form-actions">
        <el-button v-permission="'contracts:supplier-contract-edit:create'" type="primary" @click="submitForm('contractForm')">保存</el-button>
        <el-button type="success" @click="previewContract" v-if="contractId">预览合同</el-button>
        <el-button @click="returnToList">返回</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import * as XLSX from 'xlsx';
import { saveContract, getContractById } from '@/api/modules/contracts.js';
import { getAllSuppliersByUnitId } from '@/api/modules/unit.js';

export default {
  name: 'SupplierContractEdit',
  data() {
    return {
      contractId: null,
      currentUnitId: null,
      supplierPartyId: null, // 保存编辑时的contractParty ID
      originalContractItems: [], // 保存原始的contractItems数据
      contractForm: {
            contract_name: '',
            contractNumber: '',
            supplier_id: '',
            delivery_date: '',
            price_method: '固定价',
            is_interest: '是',
            settlement_method: '每月20日结算',
            payment_days: '',
            payment_days_second: '',
            interest_condition: '',
            interest_type: '固定利率',
            fixed_interest_rate: '0.00',
            products: []
          },
      variableRates: [], // 使用数组存储变动利率
      showSecondVariableRate: false,
      supplierOptions: [],
      rules: {
        contract_name: [
          { required: true, message: '请输入合同名称', trigger: 'blur' }
        ],
        supplier_id: [
          { required: true, message: '请选择供应商', trigger: 'change' }
        ],
        delivery_date: [
          { required: true, message: '请选择交付时间', trigger: 'change' }
        ]
      }
    }
  },
  created() {
    // 获取当前用户的单位ID
    this.getCurrentUnitId();
    // 先获取单位ID，然后再调用获取供应商列表
    // 延迟执行确保获取到unitId
    this.$nextTick(() => {
      this.fetchSuppliers();
    });
    this.contractId = this.$route.params.id;
    if (this.contractId) {
      this.fetchContractDetail();
    } else {
      // 默认添加一个空的变动利率
      this.addVariableRate();
    }
  },
  methods: {
    getCurrentUnitId() {
      try {
        const userInfo = this.$store.state.userInfo || {};
        if (userInfo.unitId) {
          this.currentUnitId = userInfo.unitId;
// 不在这里调用fetchSupplierList，避免重复调用
        } else {
          console.warn('未能从用户信息中获取unitId');
          this.$message.error('无法获取当前单位信息，请重新登录');
        }
      } catch (err) {
        console.error('获取用户unitId出错:', err);
        this.$message.error('获取单位信息失败');
      }
    },
    fetchSuppliers() {
      // 获取供应商列表 - 使用新的不分页接口
      if (!this.currentUnitId) {
        this.$message.error('无法获取当前单位信息，请重新登录');
        return;
      }
      
// 使用新的获取所有供应商的API
      getAllSuppliersByUnitId(this.currentUnitId)
        .then(response => {
if (response.data && response.data.success) {
            const suppliers = response.data.data || [];
// 处理供应商数据，使用camelCase字段名
            this.supplierOptions = suppliers.map(supplier => ({
              id: supplier.id,
              unit_id: supplier.id, // 兼容旧的字段名
              unit_name: supplier.unitName
            }));
            
} else {
            console.error('获取供应商列表失败:', response.data?.message || '未知错误');
            this.$message.error(response.data?.message || '获取供应商列表失败');
          }
        })
        .catch(error => {
          console.error('获取供应商列表失败:', error);
          this.$message.error('获取供应商列表失败: ' + (error.message || '未知错误'));
        });
    },
    fetchContractDetail() {
      // 获取合同详情
      if (!this.contractId) return;
      
      // 使用新的统一API获取合同详情
      getContractById(this.contractId).then(response => {
if (response.data && response.data.success) {
          const contractData = response.data.data;
// 新API返回的数据结构使用camelCase
// 提取支付条件中的天数
          let paymentDays = contractData.payment70PercentDays?.toString() || '';
          let paymentDaysSecond = contractData.paymentFullDays?.toString() || '';
          
          // 根据interestRateType确定利率类型
          const interestType = contractData.interestRateType === 'FIXED' ? '固定利率' : '变动利率';
          
          // 从contractParties中提取供应商ID和partyId
          let supplierId = '';
          if (contractData.contractParties && contractData.contractParties.length > 0) {
            const supplier = contractData.contractParties.find(party => party.partyType === 'SUPPLIER');
            if (supplier) {
              supplierId = supplier.unitInfo?.id || supplier.unitInfoId;
              this.supplierPartyId = supplier.id; // 保存contractParty的ID
            }
          }
          
          // 格式化交付时间
          let deliveryDate = '';
          if (contractData.contractDate) {
            deliveryDate = contractData.contractDate.split('T')[0];
          }
          
          // 映射计价方式
          const pricingMethodMap = {
            'FIXED': '固定价',
            'VARIABLE': '变动价'
          };
          
          // 保存原始的contractItems数据
          this.originalContractItems = contractData.contractItems || [];
          
          // 映射API数据到表单
          this.contractForm = {
          ...this.contractForm,
            contract_name: contractData.contractName || '',
            contractNumber: contractData.contractNumber || '',
            supplier_id: supplierId,
            delivery_date: deliveryDate,
            price_method: pricingMethodMap[contractData.pricingMethod] || '固定价',
            is_interest: contractData.interestCalculation ? '是' : '否',
            settlement_method: contractData.settlementMethod || '每月20日结算',
            payment_days: paymentDays,
            payment_days_second: paymentDaysSecond,
            interest_condition: contractData.interestFreeDays?.toString() || '',
            interest_type: interestType,
            fixed_interest_rate: contractData.fixedInterestRate?.toString() || '0.00',
            // 处理产品数据 - 使用新API的contractItems字段
            products: (contractData.contractItems || []).map((item, index) => ({
              originalId: item.id, // 保存原始ID，用于跟踪是否为已存在的数据
              category: item.remark || '', // 使用remark作为分类
              seq_no: (index + 1).toString(), // 使用索引作为序号
              material_name: item.productName || '', // 使用productName
              spec_model: item.specification || '',
              unit: item.unit || '',
              quantity: item.quantity?.toString() || '',
              unit_price: item.unitPrice?.toString() || '',
              tax_rate: item.taxRate ? item.taxRate.toString() : '0', // 使用taxRate字段，确保不为null
              tax_price: item.totalAmount?.toString() || '' // 使用totalAmount
            }))
          };
          
// 处理变动利率 - 新API可能没有这个字段，保持兼容
          if (contractData.variableInterestRates && contractData.variableInterestRates.length > 0) {
            this.variableRates = contractData.variableInterestRates.map(item => ({
              id: item.id,
              days: item.days || '',
              rate: item.rate || ''
            }));
          } else if (interestType === '变动利率') {
            // 默认添加一个空的变动利率
            this.addVariableRate();
          }
          
          this.$message.success('合同详情获取成功');
        } else {
          this.$message.error(response.data.message || '获取合同详情失败');
        }
      }).catch(error => {
        console.error('获取合同详情失败:', error);
        this.$message.error('获取合同详情失败: ' + (error.response?.data?.message || error.message || '未知错误'));
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          const isEdit = !!this.contractId;
          
          // 准备提交数据，按照新统一API的参数要求
          const submitData = {
            // 仅在编辑模式下包含id字段
            ...(isEdit ? { id: parseInt(this.contractId) } : {}),
            contractName: this.contractForm.contract_name,
            contractNumber: this.contractForm.contractNumber,
            contractType: 'PURCHASE', // 采购合同类型
            contractDate: this.contractForm.delivery_date + 'T00:00:00', // ISO格式日期
            pricingMethod: this.contractForm.price_method === '固定价' ? 'FIXED' : 'VARIABLE',
            interestCalculation: this.contractForm.is_interest === '是',
            settlementMethod: this.contractForm.settlement_method,
            payment70PercentDays: parseInt(this.contractForm.payment_days) || 30,
            paymentFullDays: parseInt(this.contractForm.payment_days_second) || 60,
            interestFreeDays: parseInt(this.contractForm.interest_condition) || 15,
            interestRateType: this.contractForm.interest_type === '固定利率' ? 'FIXED' : 'VARIABLE',
            fixedInterestRate: this.contractForm.interest_type === '固定利率' 
              ? parseFloat(this.contractForm.fixed_interest_rate || '0.00')
              : 0,
            // 合同参与方 - 供应商
            contractParties: [
              {
                ...(isEdit && this.supplierPartyId ? { id: this.supplierPartyId } : {}), // 编辑时包含现有的party ID
                unitInfoId: parseInt(this.contractForm.supplier_id),
                partyType: 'SUPPLIER',
                isPrimary: true,
                remark: '主要供应商'
              }
            ],
            // 合同明细项目 - 重新构造contractItems，保持原有ID
            contractItems: this.contractForm.products.map(item => ({
              ...(isEdit && item.originalId ? { id: item.originalId } : {}), // 如果有原始ID，就保持原有ID
              productName: item.material_name || '',
              specification: item.spec_model || '',
              unit: item.unit || '',
              quantity: parseFloat(item.quantity) || 0,
              unitPrice: parseFloat(item.unit_price) || 0,
              totalAmount: parseFloat(item.tax_price) || (parseFloat(item.quantity) * parseFloat(item.unit_price)),
              taxRate: parseFloat(item.tax_rate) || 0, // 添加taxRate字段
              remark: item.category || ''
            })),
            // 处理变动利率
            variableInterestRates: this.contractForm.interest_type === '变动利率' 
              ? this.variableRates.map(rate => ({
                  ...(rate.id ? { id: rate.id } : {}),
                  days: parseInt(rate.days) || 0,
                  rate: parseFloat(rate.rate) || 0
                }))
              : []
          };
          
          // 计算合同总金额
          submitData.contractAmount = submitData.contractItems.reduce((sum, item) => {
            return sum + (item.totalAmount || 0);
          }, 0);
          
          this.$message.success(`正在${isEdit ? '更新' : '创建'}合同数据...`);
          
          // 调试信息：记录当前操作的明细
          
          
// 使用新的统一合同API
          saveContract(submitData).then(response => {
if (response.data && response.data.success) {
              this.$message.success(`${isEdit ? '更新' : '创建'}合同成功`);
              
              // 保存成功后返回
              setTimeout(() => {
                this.returnToList();
              }, 500);
            } else {
              this.$message.error(response.data.message || `${isEdit ? '更新' : '创建'}合同失败`);
            }
          }).catch(error => {
            console.error(`${isEdit ? '更新' : '创建'}合同失败:`, error);
            this.$message.error(`${isEdit ? '更新' : '创建'}合同失败: ` + (error.message || '未知错误'));
          });
        } else {
          return false;
        }
      });
    },
    previewContract() {
      // 添加调试日志
// 判断是否有合同ID
      const contractId = this.contractId || 'new';
      
      // 直接跳转到供应商合同预览页面
      this.$router.push({
        path: `/contracts/supplier/preview/${contractId}`
      }).catch(err => {
        console.error('预览页面跳转失败:', err);
        this.$message.error('跳转到预览页面失败');
      });
    },
    goBack(needRefresh = false) {
      // 简化返回逻辑，确保在所有情况下都能正确返回
// 构建目标路径，添加刷新参数（如果需要）
      const targetPath = '/contracts/supplier-contracts-list';
      const targetUrl = needRefresh ? `${targetPath}?refresh=true` : targetPath;
      
      try {
        // 返回合同列表页面
        this.$router.push(targetUrl).catch(err => {
          console.error('路由导航失败:', err);
          // 如果常规导航失败，尝试直接修改浏览器地址
          window.location.href = `/#${targetUrl}`;
        });
      } catch (error) {
        console.error('返回管理页面出错:', error);
        // 兜底方案：直接修改浏览器地址
        window.location.href = `/#${targetUrl}`;
      }
    },
    beforeExcelUpload(file) {
      const isExcel = 
        file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || 
        file.type === 'application/vnd.ms-excel' ||
        file.name.endsWith('.xlsx') ||
        file.name.endsWith('.xls');
        
      if (!isExcel) {
        this.$message.error('只能上传Excel文件!');
        return false;
      }
      
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('文件大小不能超过5MB!');
        return false;
      }
      
      return true;
    },
    handleExcelUpload({ file }) {
      const loading = this.$loading({
        lock: true,
        text: '正在解析Excel文件...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      
      // 使用FileReader读取文件
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          
          // 获取第一个工作表
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          
          // 将工作表转换为JSON
          const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
          
          // 处理数据 - 跳过标题行
          if (jsonData && jsonData.length > 1) {
            // const headers = jsonData[0]; // 第一行是标题（暂未使用）
            const products = [];
            
            // 从第二行开始处理数据
            for (let i = 1; i < jsonData.length; i++) {
              const row = jsonData[i];
              if (row.length > 0 && row[0]) { // 确保行不为空
                const product = {
                  category: row[0] || '',
                  seq_no: i.toString(),
                  material_name: row[1] || '',
                  spec_model: row[2] || '',
                  unit: row[3] || '',
                  quantity: row[4] || '',
                  unit_price: row[5] || '',
                  tax_rate: row[6] != null && row[6] !== '' ? row[6] : '0', // 保持原始格式，避免转换问题
                  tax_price: row[7] || ''
                  // 不再包含 supplier_name 字段，因为商品默认属于选择的供应商
                };
                products.push(product);
              }
            }
            
            this.contractForm.products = products;
            this.$message.success(`成功导入 ${products.length} 条记录`);
          } else {
            this.$message.warning('导入的Excel文件没有有效数据');
          }
          
          loading.close();
        } catch (error) {
          console.error('解析Excel文件失败:', error);
          this.$message.error('解析Excel文件失败，请检查文件格式');
          loading.close();
        }
      };
      
      reader.onerror = () => {
        this.$message.error('读取文件失败');
        loading.close();
      };
      
      reader.readAsArrayBuffer(file);
    },
    removeProduct(index) {
this.$confirm('确定要删除该行记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 直接从数组中移除该产品，就这么简单
        this.contractForm.products.splice(index, 1);
this.$message.success('删除成功');
      }).catch(() => {
        // 用户取消删除操作
      });
    },
    removeSecondVariableRate() {
      this.contractForm.variable_days_second = '';
      this.contractForm.variable_rate_second = '';
      this.showSecondVariableRate = false;
    },
    // 新增变动利率
    addVariableRate() {
      this.variableRates.push({
        days: '',
        rate: ''
      });
    },
    // 删除变动利率
    removeVariableRate(index) {
      this.variableRates.splice(index, 1);
      
      // 确保至少有一个变动利率记录
      if (this.variableRates.length === 0) {
        this.addVariableRate();
      }
    },
    returnToList() {
// 使用最简单直接的方式导航
      window.location.href = '/#/contracts/supplier-contracts-list';
    },
    // 格式化税率显示（添加%符号）
    formatTaxRate(value) {
      if (value === null || value === undefined || value === '') return '0%';
      const num = parseFloat(value);
      if (isNaN(num)) return '0%';
      // 如果值小于1，说明是小数形式（如0.13），转换为百分比形式（13）
      if (num < 1 && num > 0) {
        return `${Math.round(num * 100)}%`;
      }
      // 如果值大于等于1，说明已经是百分比形式（如13），直接返回
      return `${Math.round(num)}%`;
    },
    
    // 格式化单价（保留8位小数，去除末尾无意义的0）
    formatUnitPrice(amount) {
      if (!amount && amount !== 0) return '0';
      const num = parseFloat(amount);
      if (isNaN(num)) return '0';
      // 先格式化为8位小数，然后去除末尾的0
      const formatted = num.toFixed(8);
      // 去除末尾的0和小数点（如果有）
      return formatted.replace(/\.?0+$/, '') || '0';
    }
  }
}
</script>

<style scoped>
.supplier-contract-edit-container {
  padding: 20px;
  background-color: #f0f2f5;
}

.page-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.blue-bar {
  width: 4px;
  height: 20px;
  background-color: #409EFF;
  margin-right: 8px;
}

.page-title {
  font-size: 18px;
  font-weight: bold;
  margin: 0;
  color: #333;
}

.contract-form {
  background-color: #fff;
  border-radius: 4px;
  padding: 20px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

.form-section {
  background-color: #fff;
  padding: 15px 20px;
  margin-bottom: 20px;
  border-radius: 4px;
  border: 1px solid #ebeef5;
}

.form-row {
  display: flex;
  margin-bottom: 20px;
}

.form-row:last-child {
  margin-bottom: 0;
}

.form-item {
  flex: 1;
  margin-right: 20px;
  display: flex;
  flex-direction: column;
}

.form-item.wide {
  flex: 3;
  max-width: 100%;
}

.form-item:last-child {
  margin-right: 0;
}

.required-label {
  font-size: 14px;
  color: #606266;
  margin-bottom: 8px;
  font-weight: normal;
}

.required-label::before {
  content: "*";
  color: #F56C6C;
  margin-right: 4px;
}

.radio-group {
  display: flex;
  align-items: center;
  height: 40px;
}

.radio-option {
  margin-right: 20px;
}

.radio-option.large {
  min-width: 200px;
}

.payment-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.payment-input-group {
  display: flex;
  align-items: center;
  height: 40px;
  margin-bottom: 10px;
}

.payment-prefix {
  width: 30px;
  text-align: right;
  color: #606266;
  margin-right: 15px;
}

.payment-second-row {
  margin-left: 0;
}

.label-text {
  margin: 0 10px;
  color: #606266;
  white-space: nowrap;
  display: inline-block;
  width: 20px;
  text-align: center;
}

.payment-text {
  margin-left: 10px;
  color: #606266;
}

.day-input {
  width: 150px !important;
}

.rate-input {
  width: 150px !important;
}

.rate-input.percent {
  width: 150px !important;
}

.interest-rate-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.interest-rate-group {
  display: flex;
  align-items: center;
  height: 40px;
  margin-bottom: 10px;
}

.rate-radio-container {
  width: 90px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.rate-inputs-container {
  display: flex;
  align-items: center;
}

.rate-inputs-container .day-input,
.rate-inputs-container .rate-input {
  margin-right: 0;
}

.rate-radio {
  width: auto;
}

.placeholder-input {
  width: 150px;
  margin: 0 10px;
}

.invisible {
  visibility: hidden;
}

.add-btn, .delete-btn {
  margin-left: 10px;
}

.add-btn {
  background-color: #409EFF;
  border-color: #409EFF;
}

.delete-btn {
  background-color: #F56C6C;
  border-color: #F56C6C;
}

.table-section {
  background-color: #fff;
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 4px;
  border: 1px solid #ebeef5;
}

.excel-uploader {
  display: inline-block;
  margin-right: 10px;
}

.import-btn {
  margin-bottom: 15px;
  background-color: #17B3A3;
  border-color: #17B3A3;
}



.form-actions {
  display: flex;
  justify-content: center;
  margin-top: 30px;
}

.form-actions .el-button {
  margin: 0 10px;
  min-width: 100px;
}

/* 覆盖Element UI的部分样式 */
::v-deep .el-input__inner,
::v-deep .el-textarea__inner {
  border-radius: 2px;
}

::v-deep .el-radio__inner {
  border-color: #DCDFE6;
}

::v-deep .el-radio__input.is-checked .el-radio__inner {
  border-color: #409EFF;
  background: #409EFF;
}

::v-deep .el-select {
  width: 100%;
}

::v-deep .el-table th {
  background-color: #f5f7fa;
}

::v-deep .el-table--border {
  border-radius: 4px;
  overflow: hidden;
}



.variable-rate-row {
  display: flex;
  margin-bottom: 10px;
}

.variable-rate-row .rate-radio-container {
  visibility: hidden;
}

.day-input {
  width: 150px !important;
}

.rate-input {
  width: 150px !important;
}

.rate-input.percent {
  width: 150px !important;
}

.add-btn, .delete-btn {
  margin-left: 10px;
}
</style>